import { useEffect, useState } from 'react';
import { useAppDispatch } from '../useAppDispatch';
import { RequestState } from '../../constants/request-state';
import { errorActions } from '../../actions';
import { loanService } from '../../services/loan.service';

export function useLoansTotalCount(enabled: boolean = true) {
    const dispatch = useAppDispatch();
    const [totalCount, setTotalCount] = useState<number>(0);
    const [requestState, setRequestState] = useState(RequestState.none);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        let cancelled = false;

        const doRequest = async () => {
            setRequestState(RequestState.request);
            try {
                const result = await loanService.getLoansTotalCount();
                if (!cancelled) {
                    setTotalCount(result);
                    setRequestState(RequestState.success);
                }
            } catch (e) {
                if (!cancelled) {
                    setRequestState(RequestState.failure);
                }
                dispatch(errorActions.unexpectedError(e));
            }
        };

        doRequest();

        return () => {
            cancelled = true;
        };
    }, [enabled, dispatch]);

    return { totalCount, requestState };
}
